export default __webpack_public_path__ + "static/media/hhs-qld-mackay.62d03b7f.svg";